<div class="action-co-body">
  <ng-container *ngIf="!modeBo; else BoContainer">
        <div class="action-co-row mb-3">

          <button *ngIf="!diabledSave" class="q-btn q-main" (click)="SaveActionCo()"><i [ngClass]="[isSaving ? 'fas fa-spinner fa-spin fa-pulse' : 'fas fa-save']"></i></button>
          <button *ngIf="diabledSave" class="q-btn q-main" disabled><i class="fas fa-save"></i></button>
          <q-avatar-search class="mr-2" *ngIf="model.Collaborateurs && model.Collaborateurs.length > 0"
                           [elementList]="model.Collaborateurs"
                           [value]="[model.IdCollabo]"
                           labelPropName="Value"
                           imgPropName="ProfilePicture"
                           identPropName="Id"
                           [nullable]="false"
                           (selectedList)="OnCollaboChange($event)"></q-avatar-search>

          <ng-container *ngIf="idActionCo && idActionCo != '0' && (actionCoService.canTransform$  | async)">
            <button [disabled]="model.lockThumb" class="q-btn-border q-success mr-2" title="Action commerciale gagnée" style="font-size: 1rem;" (click)="OnThumbClicked('up')"><i class="far fa-thumbs-up"></i></button>
            <button [disabled]="model.lockThumb" class="q-btn-border q-danger mr-2" title="Action commerciale perdue" style="font-size: 1rem;" (click)="OnThumbClicked('down')"><i class="far fa-thumbs-down"></i></button>
          </ng-container>

          <div *ngIf="model.Date" [ngClass]="[ClockBackground()]" class="rounded-button clock ml-1"
               [ngbPopover]="f2"
               placement="bottom"
               [autoClose]="'outside'"
               #p2="ngbPopover"
               (click)="datepiquerPopover = p2;"
               title="{{model.Date | NumberOfQueovalDay}} {{model.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'long'}} {{model.Date | NumberOfQueovalYear}} à {{model.Date.heures ? model.Date.heures : '00'}}:{{model.Date.minutes ? model.Date.minutes : '00'}}">
            <i class="far fa-clock mr-1"></i> {{model.Date | NumberOfQueovalDay}} {{model.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{model.Date | NumberOfQueovalYear}}
          </div>
          <ng-template #f2>
            <ngb-datepicker #d [startDate]="datePickerModel" [ngModel]="datePickerModel" (ngModelChange)="dateChange($event)"></ngb-datepicker>
            <div *ngIf="model.DateMinutesList && model.DateMinutesList.length > 0" class="action-co-row">
              <div class="col-6 mt-2 pl-0">
                <select class="q-main-select w-100" [ngModel]="model.Date.heures" (change)="OnHourChange($event.target.value)">
                  <option *ngFor="let hour of [].constructor(24); let i = index" [value]="i < 10 ? '0' + i : i">{{i < 10 ? '0' + i : i}}</option>
                </select>
              </div>
              <div class="col-6 mt-2 pr-0">
                <select class="q-main-select w-100" [ngModel]="model.Date.minutes" (change)="OnMinutesChange($event.target.value)">
                  <option *ngFor="let minutes of model.DateMinutesList; let i = index" [value]="minutes">{{minutes}}</option>
                </select>
              </div>
            </div>
            <div class="action-co-row">
              <button class="q-btn q-white w-100 mx-0 mt-2" (click)="dateGetNow();"><i class="far fa-calendar-check q-c-main mr-2"></i>Aujourd'hui</button>
            </div>
          </ng-template>

          <ng-container *ngIf="propsWithoutCombo > 0">
            <ng-container *ngFor="let dtProp of model.requiredProps">
              <ng-container *ngIf="dtProp.Type == 'DATE'">
                <div [ngClass]="[dtProp.highlight ? 'q-danger' : 'q-dark-secondary']" class="rounded-button clock ml-1"
                     [ngbPopover]="f7"
                     placement="bottom"
                     [autoClose]="'outside'"
                     #p7="ngbPopover"
                     (click)="datepiquerPopover = p7; PropPopover = dtProp;"
                     title="{{ !qDateService.IsNull(dtProp.Value) ? (dtProp.Value| NumberOfQueovalDay) : ''}} {{ !qDateService.IsNull(dtProp.Value) ? (dtProp.Value | MonthOfQueovalDate : indParam.AppParams.culture: 'long') : ''}}{{ !qDateService.IsNull(dtProp.Value) ? (dtProp.Value| NumberOfQueovalYear) : ''}}{{ !qDateService.IsNull(dtProp.Value) ? (dtProp.DateMinutesList && dtProp.DateMinutesList.length > 0 ? (' à ' + (dtProp.Value.heures ? dtProp.Value.heures : '00') + ':' + (dtProp.Value.minutes ? dtProp.Value.minutes : '00')) : '') : ''}}">
                  <i class="far fa-clock mr-1"></i>{{dtProp.Label}} : {{ !qDateService.IsNull(dtProp.Value) ? (dtProp.Value | NumberOfQueovalDay) : ''}} {{ !qDateService.IsNull(dtProp.Value) ? (dtProp.Value | MonthOfQueovalDate: indParam.AppParams.culture: 'short') : ''}} {{ !qDateService.IsNull(dtProp.Value) ? (dtProp.Value| NumberOfQueovalYear) : ''}}

                </div>
                <ng-template #f7>
                  <ngb-datepicker #d [startDate]="{year:PropPopover.Value.Year, month:PropPopover.Value.Month, day:PropPopover.Value.Day}" [ngModel]="{year:PropPopover.Value.Year, month:PropPopover.Value.Month, day:PropPopover.Value.Day}" (ngModelChange)="datePropChange(PropPopover, $event); PropPopover.highlight = false;"></ngb-datepicker>
                  <div *ngIf="PropPopover.DateMinutesList && PropPopover.DateMinutesList.length > 0" class="action-co-row">
                    <div class="col-6 mt-2 pl-0">
                      <select class="q-main-select w-100" [ngModel]="PropPopover.Value.heures" (change)="OnPropHourChange(PropPopover, $event.target.value)">
                        <option *ngFor="let hour of [].constructor(24); let i = index" [value]="i < 10 ? '0' + i : i">{{i < 10 ? '0' + i : i}}</option>
                      </select>
                    </div>
                    <div class="col-6 mt-2 pr-0">
                      <select class="q-main-select w-100" [ngModel]="PropPopover.Value.minutes" (change)="OnPropMinutesChange(PropPopover, $event.target.value)">
                        <option *ngFor="let minutes of PropPopover.DateMinutesList; let i = index" [value]="minutes">{{minutes}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="action-co-row">
                    <button class="q-btn q-white w-100 mx-0 mt-2" (click)="datepiquerPopover.close();"><i class="far fa-calendar-check q-c-main"></i></button>
                  </div>

                </ng-template>

              </ng-container>
            </ng-container>
          </ng-container>

          <button *ngIf="model.Amount" title="{{model.InfoProjet}}" class="rounded-button q-dark-secondary ml-1">{{model.Amount}} {{indParam.AppParams.Devise}}</button>

          <div class="rounded-button q-dark-secondary ml-1 q-pointer"
               [ngbPopover]="f3"
               placement="bottom"
               [autoClose]="'outside'"
               #p3="ngbPopover"
               (click)="TypePopover = p3">
            <i class="fas fa-columns mr-1"></i>
            {{AfficheSelectedType(model.Type)}}
          </div>
          <ng-template #f3>
            <ng-container *ngFor="let type of model?.TypesList; let i = index">
              <div class="select-type q-pointer px-2" (click)="OnChangeType(type.key)">{{type.value}}</div>
            </ng-container>
          </ng-template>

          <ng-container *ngFor="let prop of model.requiredProps">
            <ng-container *ngIf="prop.Combo && prop.Combo.length > 0 && (prop.Type == 'STRING' || prop.Type == 'INT' || prop.Type == 'MONETARY')">
              <div [ngClass]="[prop.highlight ? 'q-danger' : 'q-dark-secondary']" class="rounded-button ml-1 q-pointer"
                   placement="bottom"
                   [autoClose]="'outside'"
                   [ngbPopover]="f4"
                   #p4="ngbPopover"
                   (click)="TypePopover = p4; PropPopover = prop">
                {{prop.Label}} : {{AfficheComboValue(prop)}}
              </div>

            </ng-container>
          </ng-container>

          <ng-template #f4>
            <ng-container *ngFor="let combo of PropPopover?.Combo; let i = index">
              <div class="select-type q-pointer px-2" (click)="OnChangeComboValue(PropPopover, combo.Value); PropPopover.highlight = false;">{{combo.Key}}</div>
            </ng-container>
          </ng-template>

          <!--<ng-container>
        <div class="ml-auto">
          <button [disabled]="!model.idActionCo || model.idActionCo == '0'" class="btn-icon q-c-light-secondary" (click)="OnOpenBo('ACO')" title="Afficher le détail de l'action commerciale"><span class="mr-1 q-text-s">Action commerciale</span><i class="fas fa-edit"></i></button>
        </div>
      </ng-container>-->
        </div>



        <div *ngIf="clickedThumb" class="action-co-row">
          <div class="mb-2 px-2 pb-2 w-100 thumb-input" [ngClass]="[clickedThumb]">
            <textarea #commentaire class="noscrollbars mb-2 pl-2" [ngClass]="[highlightThumbComment ? 'q-danger': 'q-light-main']" (blur)="highlightThumbComment = false;" (keyup)="TexteareaAutoGrow($event);" rows="1" [placeholder]="clickedThumb === 'up' ?  'Ecrire un commentaire pour l action commerciale gagnée *(obligatoire)' : 'Ecrire un commentaire pour l action commerciale perdue *(obligatoire)'" [(ngModel)]="model.Remark"></textarea>
            <select class="q-main-select" [(ngModel)]="ThumbBoTypeValue" required>
              <option *ngFor="let type of HistoryBoTypes" [value]="type.id">{{type.value}}</option>
            </select>
            <select *ngIf="clickedThumb === 'down'" class="q-main-select ml-2" [ngClass]="[highlightThumbStatus ? 'q-danger': 'q-light-main']" (blur)="highlightThumbStatus = false;" required [(ngModel)]="model.Reason">
              <option value="" disabled selected>Motif *(obligatoire)</option>
              <option *ngFor="let reason of model.ReasonsList" [value]="reason.key">{{reason.value}}</option>
            </select>
          </div>
        </div>

        <!-- Personne Morale et Contact Principal-->
        <div class="action-co-row">
          <div class="col-5 col-lg-3 h-100 pr-0">
            <h5 class="underlined-title">{{Customer.PersonneMorale}}</h5>
            <hr class="mb-3" />
          </div>
          <div class="col-1 col-lg-1 h-100 pl-0">
            <div class="row col-12 ml-auto">
              <button [disabled]="!model.Customer.Id || model.Customer.Id == '0'" class="ml-auto btn-icon q-c-light-secondary" (click)="OnOpenBo('PM_EDIT')" title="Afficher le détail du {{Customer.PersonneMorale}}"><span class="mr-1 q-text-s"></span><i class="fas fa-edit"></i></button>
            </div>
            <hr class="mb-3" />
          </div>

          <div class="col-5 col-lg-3 h-100 pr-0">
            <h5 class="col-9 underlined-title">Contact principal</h5>
            <hr class="mb-3" />
          </div>

          <div class="col-1 col-lg-1 h-100 pl-0">
            <div class="row col-12 ml-auto">
              <button [disabled]="!model.ContactPrincipal.Id || model.ContactPrincipal.Id == '0'" class="ml-auto btn-icon q-c-light-secondary" (click)="OnOpenBo('PP_EDIT')" title="Afficher le détail de la personne physique"><span class="mr-1 q-text-s"></span><i class="fas fa-edit"></i></button>
            </div>
            <hr class="mb-3" />
          </div>

        </div>

        <div class="action-co-row">
          <!--<h5 class="underlined-title">Personne morale</h5>
      <hr />-->
          <ng-container *ngIf="Customer && Customer.Id; else autosearchCustomer">
            <div class="col-6 col-lg-4 h-100">
              <div class="action-co-row q-bold mobile-font-size-10 q-light-grey" style="height:34px">{{Customer.SocialReason}}</div>
              <div class="row mt-1 mb-1">
                <div *ngIf="Customer.HomePhoneNumber" class="col-6 q-c-secondary q-text-m action-co-row mobile-font-size-10">
                  <a href="tel:{{Customer.HomePhoneNumber}}">
                    <i class="fas fa-phone-square" title="Numéro de téléphone fixe"></i>
                  </a>
                  <span class="ml-1">{{Customer.HomePhoneNumber}}</span>
                </div>
                <div *ngIf="Customer.PhoneNumber" class="col-6 q-c-secondary q-text-m action-co-row mobile-font-size-10">
                  <a href="tel:{{Customer.PhoneNumber}}">
                    <i class="fas fa-mobile-alt" title="Numéro de téléphone portable"></i>
                  </a>
                  <span class="ml-1">{{Customer.PhoneNumber}}</span>
                </div>
              </div>
              <div *ngIf="Customer.Email" class="q-c-secondary q-text-m action-co-row mobile-font-size-10">
                <a href="{{Customer.MailTo}}" target="blank">
                  <i class="fas fa-at" title="Adresse courrier électronique"></i>
                </a>
                <span class="ml-1">{{Customer.Email}}</span>
              </div>
            </div>
          </ng-container>

          <ng-template #autosearchCustomer>
            <div class="col-6 col-lg-4 h-100">
              <div class="action-co-row flex-nowrap">
                <div class="autosearch-container">
                  <q-autosearch Mode="CLIENT" [InputWithDelete]="false" class="w-100" CustomClass="q-input-required q-input-no-border q-c-light-black q-bold"
                                [InputText]="model.Customer.SocialReason"
                                (SetInput)="OnCustomerChange($event)"></q-autosearch>
                </div>
                <div class="d-flex align-items-center">
                  <button class="q-btn q-white action-co-btn-plus m-0 ml-2" (click)="showCreatePMDiv = !showCreatePMDiv"><i class="fas fa-plus"></i></button>
                  <!-- POP UP création individuel ou entreprise -->
                  <div *ngIf="showCreatePMDiv" class="popOverCreaPM">
                    <button (click)="OnOpenBo('PM')" class="q-btn mb-2 mr-0">Entreprise</button>
                    <button (click)="OnOpenBo('IND')" class="q-btn mr-0">Individuel</button>
                  </div>
                </div>
              </div>
              <div *ngIf="model.Customer && model.Customer.Id && model.Customer.Id != '0'" class="row mt-1 mb-1">
                <div *ngIf="model.Customer.HomePhoneNumber" class="col-6 q-c-secondary q-text-m action-co-row mobile-font-size-10">
                  <a href="tel:{{model.Customer.HomePhoneNumber}}">
                    <i class="fas fa-phone-square" title="Numéro de téléphone fixe"></i>
                  </a>
                  <span class="ml-1">{{model.Customer.HomePhoneNumber}}</span>
                </div>
                <div *ngIf="model.Customer.PhoneNumber" class="col-6 q-c-secondary q-text-m action-co-row mobile-font-size-10">
                  <a href="tel:{{model.Customer.PhoneNumber}}">
                    <i class="fas fa-mobile-alt" title="Numéro de téléphone portable"></i>
                  </a>
                  <span class="ml-1">{{model.Customer.PhoneNumber}}</span>
                </div>
              </div>
              <div *ngIf="model.Customer && model.Customer.Id && model.Customer.Id != '0' && model.Customer.Email" class="q-c-secondary q-text-m action-co-row mobile-font-size-10">
                <a href="{{model.Customer.MailTo}}" target="blank">
                  <i class="fas fa-at" title="Adresse courrier électronique"></i>
                </a>
                <span class="ml-1">{{model.Customer.Email}}</span>
              </div>

            </div>
          </ng-template>



          <div class="col-6 col-lg-4 h-100">
            <!--<h5 class="underlined-title">Contact principal</h5>
        <hr />-->
            <div class="action-co-row">
              <div [ngClass]="[model.Customer.Id ? 'autosearch-container' : 'w-100']">
                <q-data-list *ngIf="!awaitNameContact"
                             class="w-100"
                             inputClass="q-input-no-border q-c-light-black q-bold"
                             [value]="this.model.ContactPrincipal.Value"
                             (qChange)="OnContactChange($event)"
                             [dataList]="dataListContact"
                             placeholder="Sélectionnez un contact"
                             validDatas
                             [deleteButton]="!!this.model.ContactPrincipal.Value"
                             nullable
                             [disabled]="!model.Customer.Id"></q-data-list>
              </div>
              <button *ngIf="model.Customer.Id" class="q-btn q-white action-co-btn-plus m-0 ml-2" (click)="OnOpenBo('PP')"><i class="fas fa-plus"></i></button>
            </div>

            <div *ngIf="!awaitNameContact" class="row mt-1 mb-1">
              <div *ngIf="model.ContactPrincipal.PhoneNumber" class="col-6 q-c-secondary q-text-m action-co-row mobile-font-size-10">
                <a href="tel:{{model.ContactPrincipal.PhoneNumber}}">
                  <i class="fas fa-phone-square" title="Numéro de téléphone fixe"></i>
                </a>
                <span class="ml-1">{{model.ContactPrincipal.PhoneNumber}}</span>
              </div>
              <div *ngIf="model.ContactPrincipal.MobilePhoneNumber" class="col-6 q-c-secondary q-text-m action-co-row mobile-font-size-10">
                <a href="tel:{{model.ContactPrincipal.MobilePhoneNumber}}">
                  <i class="fas fa-mobile-alt" title="Numéro de téléphone portable"></i>
                </a>
                <span class="ml-1">{{model.ContactPrincipal.MobilePhoneNumber}}</span>
              </div>
            </div>
            <div *ngIf="!awaitNameContact && model.ContactPrincipal.Email" class="q-c-secondary q-text-m action-co-row mobile-font-size-10">
              <a href="{{model.ContactPrincipal.MailTo}}" target="blank">
                <i class="fas fa-at" title="Adresse courrier électronique"></i>
              </a>
              <span class="ml-1">{{model.ContactPrincipal.Email}}</span>
            </div>

          </div>

        </div>

        <!-- Etat de l'action commerciale : Gagne ou Perdu -->
        <div class="action-co-row mb-0 mt-3">
          <!-- Action commerciale -->
          <div *ngIf="!model.lockThumb" class="col-8 pr-0">
            <h5 class=" underlined-title">Action commerciale</h5>
            <hr class="mb-0" />
          </div>
          <!-- Afficher si Etat de l'action commerciale : Gagne -->
          <div *ngIf="model.lockThumb && model.Status === 'Gagne'" class="col-8 pr-0">
            <h5 class="underlined-title">
              <i title="{{model.Status}}" class="far fa-thumbs-up q-c-main mr-2"></i>
              Action commerciale gagnée
              <span *ngIf="model.Remark" class="rounded-button q-dark-secondary ml-2" title="Commentaire">{{model.Remark}}</span>
            </h5>
            <hr class="mb-0" />
          </div>
          <!-- Afficher si Etat de l'action commerciale : Perdu -->
          <div *ngIf="model.lockThumb && model.Status !== 'Gagne'" class="col-8 pr-0">
            <h5 class="underlined-title q-c-danger">
              <i title="{{model.Status}}" class="far fa-thumbs-down q-c-danger mr-2"></i>
              Action commerciale perdue
              <span *ngIf="model.Reason" class="rounded-button q-dark-secondary ml-2" title="Motif - Commentaire">{{model.Reason ? model.Reason : ''}}{{model.Remark ? ' - ' + model.Remark : ''}}</span>
            </h5>
            <hr class="mb-0" />
          </div>
          <!--Ouverture du BO de l'action commerciale -->
          <div class="col-4 col-lg-4 pl-0">
            <div class="row col-12 ml-auto">
              <button [disabled]="!model.idActionCo || model.idActionCo == '0'" class="ml-auto btn-icon q-c-light-secondary" (click)="OnOpenBo('ACO')" title="Afficher le détail de l'action commerciale"><span class="ml-auto col-auto q-text-s"></span><i class="fas fa-edit"></i></button>
            </div>
            <hr class="mb-0" />
          </div>
        </div>

        <!-- Sujet sur l'action commerciale -->
        <div class="action-co-row mb-2 mb-sm-2">
          <div class="col-12">
            <p class="q-c-light-black q-bold font-size-13 mt-2 mb-0">Sujet</p>
          </div>
          <div class="col-12">
            <input type="text" [ngClass]="[highlightSujet ? 'q-danger': 'q-light-main']" (blur)="highlightSujet = false;" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="model.Sujet" required />
          </div>
        </div>
        <!-- Description sur l'action commerciale -->
        <div class="action-co-row mb-2 mb-sm-2">
          <div class="col-12">
            <p class=" q-c-light-black q-bold font-size-13 mb-0">Description</p>
          </div>
          <div class="col-12">
            <textarea #description rows="5" class="font-size-13 q-input-no-border w-100 q-c-light-black" [ngClass]="[model?.DescriptionRequired ? (highlightDescription ? 'q-danger' : 'q-light-main') : '']" (blur)="highlightDescription = false;" [(ngModel)]="model.Description" [required]="model?.DescriptionRequired"></textarea>
          </div>
        </div>
        <!-- # tag -->
        <div class="action-co-row mb-2 mb-sm-2">
          <div class="col-12">
            <p class=" q-c-light-black q-bold font-size-13 mb-0">Tags</p>
          </div>
          <div class="col-12">
            <q-tag class="mt-2" idPere="{{model.idActionCo}}" relation="REL_BO_ACTIONCO_BO_TAG" #tagComp></q-tag>
          </div>
        </div>

        <!-- Affichage des propriétés obligatoires du BO Action CO TextBox Alpha ou Monetaire, CheckBox -->
        <div *ngIf="propsWithoutCombo > 0" class="action-co-row mb-2 mb-sm-2">


          <ng-container *ngFor="let prop of model.requiredProps; let i = index;">
            <ng-container *ngIf="(!prop.Combo || prop.Combo.length < 1) && prop.Type != 'DATE'">
              <div class="p-0" [ngClass]="[propsWithoutCombo > 2 ? 'col-md-6 col-lg-4' : propsWithoutCombo == 2 ? 'col-lg-6': 'col-12']">
                <ng-container [ngSwitch]="prop.Type">
                  <ng-container *ngSwitchCase="'STRING'">
                    <div class="col-12">
                      <p class=" q-c-light-black q-bold font-size-13 mb-0"> {{prop.Label}}</p>
                    </div>
                    <div class="col-12">
                      <input type="text" (blur)="prop.highlight = false;" [ngClass]="[prop.highlight ? 'q-danger' : '']" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="prop.Value" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'INT'">
                    <div class="col-12">
                      <p class=" q-c-light-black q-bold font-size-13 mb-0"> {{prop.Label}}</p>
                    </div>
                    <div class="col-12">
                      <input type="number" (blur)="prop.highlight = false;" [ngClass]="[prop.highlight ? 'q-danger' : '']" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="prop.Value" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'MONETARY'">
                    <div class="col-12">
                      <p class=" q-c-light-black q-bold font-size-13 mb-0"> {{prop.Label}}</p>
                    </div>
                    <div class="col-12">
                      <input type="number" step="0.01" (blur)="prop.highlight = false;" [ngClass]="[prop.highlight ? 'q-danger' : '']" class="q-input-no-border w-100 q-c-light-black" [(ngModel)]="prop.Value" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'BOOLEAN'">
                    <div class="q-check col-12">
                      <input type="checkbox" id="check-{{i}}" [(ngModel)]="prop.Value" />
                      <label for="check-{{i}}">
                        <span></span>{{prop.Label}}
                      </label>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>


        <!-- Info du devis -->
        <div *ngIf="model.Invoice.Ident && model.Invoice.Path" class="action-co-row mb-2 mb-sm-2">
          <div class="d-flex q-pointer" (click)="OpenInvoice()">
            <div><i class="fas fa-paperclip fa-2x q-c-dark-grey mr-2"></i></div>
            <div>
              <p class="invoice-date">{{model.Invoice.Date | NumberOfQueovalDay}} {{model.Invoice.Date | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{model.Invoice.Date | NumberOfQueovalYear}} {{model.Invoice.Date.heures && model.Invoice.Date.minutes && model.Invoice.Date.secondes && model.Invoice.Date.heures != '00' && model.Invoice.Date.minutes != '00' && model.Invoice.Date.secondes != '00' ? 'à ' + (model.Invoice.Date.heures ? model.Invoice.Date.heures : '00') + ':' + (model.Invoice.Date.minutes ? model.Invoice.Date.minutes : '00') : ''}}</p>
              <p class="invoice-name">{{model.Invoice.Name}}</p>
            </div>
          </div>
        </div>

        <!-- Nouveau commentaire à la création de l'action co'-->
        <div class="newhistory-row position-relative" *ngIf="!idActionCo || idActionCo === '' || idActionCo === '0'">
          <div class="col mx-3 p-0 q-input-no-border">
            <textarea [(ngModel)]="HistoryNewComment"
                      [ngClass]="[emptyComment ? 'q-danger' : '']"
                      class="q-input-no-border noscrollbars pl-2"
                      (blur)="emptyComment = false;"
                      (keyup)="TexteareaAutoGrow($event);" rows="1" placeholder="Ecrire un commentaire"></textarea>
            <select class="q-main-select m-2" [(ngModel)]="HistoryBoTypeValue" required>
              <option *ngFor="let type of HistoryBoTypes" [value]="type.id">{{type.value}}</option>
            </select>
          </div>
        </div>

        <!--Composant historique-->
        <q-history *ngIf="idActionCo && idActionCo != '0'" style="min-height:600px" class="col" [Type]="'ACTIONCO'" [Ident]="idActionCo" (sendHistory)="updateHistory($event)"></q-history>


  </ng-container>
  <ng-template #BoContainer>
    <h2 *ngIf="modeBo == 'INDIVIDUEL'">Création d'un individuel</h2>
    <q-action-co-bo style="max-width: 100%;" *ngIf="modeBo === 'CUSTOMER'" [mode]="modeBo" (close)="OnCloseBo('CUSTOMER', $event)"></q-action-co-bo>
    <q-action-co-bo style="max-width: 100%;" *ngIf="modeBo == 'INDIVIDUEL'" [mode]="modeBo" (close)="OnCloseBo('INDIVIDUEL', $event)"></q-action-co-bo>
    <q-action-co-bo style="max-width: 100%;" *ngIf="modeBo === 'CONTACT'" [mode]="modeBo" [idDonneePere]="model.Customer.Id" (close)="OnCloseBo('CONTACT', $event)"></q-action-co-bo>
    <q-action-co-bo style="max-width: 100%;" *ngIf="modeBo === 'ACTIONCO'" [mode]="modeBo" [idDonneePere]="model.Customer.Id" [idDonneeFils]="model.idActionCo" (close)="OnCloseBo('ACTIONCO', $event)"></q-action-co-bo>
    <q-action-co-bo style="max-width: 100%;" *ngIf="modeBo === 'PM_EDIT'" [mode]="modeBo" [idDonneePere]="" [idDonneeFils]="model.Customer.Id" (close)="OnCloseBo('PM_EDIT', $event)"></q-action-co-bo>
    <q-action-co-bo style="max-width: 100%;" *ngIf="modeBo === 'PP_EDIT'" [mode]="modeBo" [idDonneePere]="" [idDonneeFils]="model.ContactPrincipal.Id" (close)="OnCloseBo('PP_EDIT', $event)"></q-action-co-bo>
  </ng-template>


</div>

